import { render, staticRenderFns } from "./IconCirclePlus.vue?vue&type=template&id=54e97b00&"
import script from "./IconCirclePlus.vue?vue&type=script&lang=js&"
export * from "./IconCirclePlus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports